import { Box, BoxProps, Text, useColorModeValue } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { KnowledgeSource } from '../../types/chatTypes'

interface AnswerLoaderProps extends BoxProps {
  knowledgeSource?: KnowledgeSource
}

export const AnswerLoader: React.FC<AnswerLoaderProps> = ({  ...props }) => {
  const [, setMessageIndex] = useState(0)
  const [showSearchMessage, setShowSearchMessage] = useState(true)
  const shimmerGradient = useColorModeValue(
    'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 50%, rgba(255,255,255,0) 100%)',
    'linear-gradient(90deg, rgba(26,32,44,0) 0%, rgba(26,32,44,0.2) 50%, rgba(26,32,44,0) 100%)'
  )
  const textColor = useColorModeValue('gray.700', 'gray.200')

  const getMessage = () => {
    // TODO: make dynamic based on customer config
    return 'Working on your answer...'
  }
  useEffect(() => {
    const interval = setInterval(() => {
      setShowSearchMessage(prev => !prev)
      if (showSearchMessage) {
        setMessageIndex(prev => (prev + 1) % 1)
      }
    }, 6000)

    return () => clearInterval(interval)
  }, [showSearchMessage])

  return (
    <Box
      {...props}
      ml={props.ml}
      position='relative'
      _after={{
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: shimmerGradient,
        animation: 'shimmer 2s infinite linear',
        zIndex: 1,
      }}
    >
      <Text
        fontSize='md'
        color={textColor}
        sx={{
          '@keyframes shimmer': {
            '0%': { transform: 'translateX(-100%)' },
            '100%': { transform: 'translateX(100%)' },
          },
        }}
      >
        {getMessage()}
      </Text>
    </Box>
  )
}
